import Commons from '../../../../Services/Common/Common';
import dayjs from 'dayjs';

/**
 * HAZ_BASIC_02 스키마
 */
export const HAZ_BASIC_02_Schema = {
  fields: {
    no: { initial: '', label: 'NO' },
    chaebun: { initial: '', label: '채번' },
    custCd: { initial: '', label: '사업장코드' },
    gubun: { initial: '', label: '구분', required: 'Y' },
    machineName: { initial: '', label: '기계·기구명', required: 'Y' },
    serialNo: { initial: '', label: '형식' },
    passNo: { initial: '', label: '인증번호' },
    capacity: { initial: '', label: '용량' },
    installLocation: { initial: '', label: '설치장소' },
    inspectionDate: { initial: '', label: '인증일자' },
    remark: { initial: '', label: '비고' },
    certificateFileName: { initial: '', label: '증명서 파일명' },
    certificateSaveName: { initial: '', label: '증명서 저장명' },
    certificateFilePath: { initial: '', label: '증명서 파일 경로' },
    previewFilePath: { initial: '', label: '미리보기 파일 경로' },
  },

  mapper: {
    search1: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
    },
    search2: {
      Gubun: (_, context) => Commons.EncryptAES('1') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },
    search3: {
      CoCd: (_, context) =>
        Commons.EncryptAES(context.userInfo?.coCd || '') || '',
      Gubun: (_, context) => Commons.EncryptAES('1') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },
    delete1: {
      Chaebun: (row) => Commons.EncryptAES(row.chaebun || '') || '',
    },
    save1: {
      Chaebun: (row) => {
        const chaebun = row.chaebun;
        const chaebunValue =
          chaebun && chaebun.toString().trim() !== '' ? chaebun.toString() : '0';
        return Commons.EncryptAES(chaebunValue) || '';
      },
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      Gubun: (row) => Commons.EncryptAES(row.gubun || '') || '',
      MachineName: (row) => Commons.EncryptAES(row.machineName || '') || '',
      SerialNo: (row) => Commons.EncryptAES(row.serialNo || '') || '',
      PassNo: (row) => Commons.EncryptAES(row.passNo || '') || '',
      Capacity: (row) => Commons.EncryptAES(row.capacity || '') || '',
      InstallLocation: (row) => Commons.EncryptAES(row.installLocation || '') || '',
      InspectionDate: (row) => {
        if (!row.inspectionDate || !dayjs(row.inspectionDate).isValid()) return '';
        return Commons.EncryptAES(dayjs(row.inspectionDate).format('YYYY-MM-DD')) || '';
      },
      Remark: (row) => Commons.EncryptAES(row.remark || '') || '',
      CertificateFileName: (row) =>
        Commons.EncryptAES(row.certificateFileName || '') || '',
      CertificateSaveName: (row) =>
        Commons.EncryptAES(row.certificateSaveName || '') || '',
      CertificateFilePath: (row, context) => {
        // 새 파일 업로드 시: previewFilePath에서 saveName 추출하여 최종 경로 생성
        const previewPath = row.previewFilePath || '';
        if (previewPath) {
          const saveName = previewPath.split('/').pop() || '';
          const finalPath = `HazardousMachines/${context.search?.custCd}/HAZ_BASIC_02/${saveName}`;
          return Commons.EncryptAES(finalPath) || '';
        }

        // 기존 파일 유지 시: certificateFilePath 직접 사용
        const existingFilePath = row.certificateFilePath || '';
        if (!existingFilePath) return '';
        return Commons.EncryptAES(existingFilePath) || '';
      },
      UserId: (_, context) => context.userInfo?.userid || '',
    },
    save2: {
      Gubun: (_, context) => Commons.EncryptAES('1') || '',
      ToggleStatus: (row) => Commons.EncryptAES(row.toggleStatus || 'N') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },
  },
};
